module.exports = __webpack_public_path__ + "static/media/skipton.cf364ed4.png";